import { render, staticRenderFns } from "./EventSideMenu.vue?vue&type=template&id=65728748&scoped=true"
import script from "./EventSideMenu.vue?vue&type=script&lang=ts"
export * from "./EventSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./EventSideMenu.vue?vue&type=style&index=0&id=65728748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65728748",
  null
  
)

export default component.exports